import { render } from "./app.vue?vue&type=template&id=e831a51a"
const script = {}
script.render = render

export default script